export default "__VITE_ASSET__BuQ8pVr3__"